import { TitleCasePipe } from '@angular/common'
import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { TranslocoModule } from '@jsverse/transloco'

import { ButtonComponent } from '../../ui/button/button.component'
import { DialogComponent } from '../../ui/dialog/dialog.component'
import { TextComponent } from '../../ui/text/text.component'

export type ConfirmDialogData = {
  cancel: string
  confirm: string
  content: string
  title: string
}

@Component({
  selector: 'sb-confirm-dialog',
  template: `<sb-dialog [title]="data.title">
    <ng-template #content>
      <sb-text [innerHTML]="data.content" noMargin />
    </ng-template>
    <ng-template #actions>
      <sb-button variant="text" (click)="onCancel()">
        {{ data.cancel || ('words.cancel' | transloco | titlecase) }}
      </sb-button>
      <sb-button (click)="onConfirm()">
        {{ data.confirm || ('words.confirm' | transloco | titlecase) }}
      </sb-button>
    </ng-template>
  </sb-dialog> `,
  standalone: true,
  imports: [DialogComponent, TextComponent, ButtonComponent, TitleCasePipe, TranslocoModule],
})
export class ConfirmDialogComponent {
  answer: boolean

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData,
  ) {}

  onCancel(): void {
    this.answer = false
    this.dialogRef.close()
  }

  onConfirm(): void {
    this.answer = true
    this.dialogRef.close()
  }
}
